import {
  Box,
  Button,
  HStack,
  Select,
  Table,
  TableContainer,
  TableContainerProps,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { useBgBaseColor } from "../../themes/colors";
import { paginationOptions } from "../../utils/etc";

interface Props extends TableContainerProps {
  columnHeader: any;
  data: any;
  totalItems?: number;
  totalPages?: number;
  onPageChange?: (page: number) => void;
  onLimitChange?: (limit: number) => void;
}

export const CustomTable = ({
  columnHeader,
  data,
  totalItems,
  totalPages,
  onPageChange,
  onLimitChange,
  ...rest
}: Props) => {
  const bgComp = useBgBaseColor();
  const pagesArr = Array.from({ length: totalPages as any }, (_, i) => i + 1);

  const handleSelect = async (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    (onLimitChange as any)(parseInt(value));
  };

  return (
    <VStack w={"100%"} mb={4}>
      <TableContainer
        className="table-container"
        w={"100%"}
        fontSize={{
          base: "10px",
          sm: "12px",
          md: "12px",
          lg: "12px",
          xl: "14px",
        }}
        display={"flex"}
        overflowX={"auto"}
        overflowY={"hidden"}
        borderWidth={"1px"}
        borderRadius={"md"}
        {...rest}
      >
        <Box
          className="box-table scrollX"
          w={"100%"}
          display={"flex"}
          overflowX={"auto"}
          overflowY={"hidden"}
        >
          <Table variant={"striped"} colorScheme="red">
            <Thead borderBottomWidth={"1px"} bg={bgComp}>
              <Tr>
                {columnHeader.map((item: any, i: any) => (
                  <Th
                    cursor={item.sortable ? "pointer" : "default"}
                    key={item.id}
                    onClick={item.onClick}
                  >
                    {item.name}
                  </Th>
                ))}
              </Tr>
            </Thead>
            <Tbody>
              {data?.map((item: any, i: any) => (
                <Tr key={i}>
                  {columnHeader.map((header: any) => (
                    <Td key={header.id}>
                      {item[header.id]}{" "}
                      {/* Access the item property using header.id */}
                    </Td>
                  ))}
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      </TableContainer>

      <HStack w={"100%"} mt={4} justify={"space-between"}>
        {totalItems && (
          <HStack>
            <Select
              size={["xs", null, "sm"]}
              w={"fit-content"}
              onChange={handleSelect}
              isDisabled={
                (totalItems as any) > paginationOptions[0].name ? false : true
              }
            >
              {paginationOptions[0].name < (totalItems as any) ? (
                paginationOptions.map((item, i) => (
                  <option key={i} value={item.name}>
                    {item.name}
                  </option>
                ))
              ) : (
                <option value={totalItems}>{totalItems}</option>
              )}
            </Select>

            <Text textStyle={"b-reg"}>{`dari ${totalItems}`}</Text>
          </HStack>
        )}

        {totalPages && (
          <HStack>
            {pagesArr.map((page: any, i: any) => (
              <Button
                key={i}
                size={"xs"}
                colorScheme="teal"
                borderRadius={"sm"}
                variant={"outline"}
                onClick={() => (onPageChange as any)(page)}
              >
                {page}
              </Button>
            ))}
          </HStack>
        )}
      </HStack>
    </VStack>
  );
};
